import { Alert, App, Form, Modal, Select } from 'antd';
import i18next from 'i18next';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'src/i18n';
import { container } from 'src/inversify.config';
import { ToolUsageCsvReportKeys, ToolUsageCsvReportRequest, ToolUsageReportStore } from 'src/stores/tools-store';

export const ToolUsageReportModal: FC<{ visible: boolean; onClose: () => void }> = ({ onClose, visible }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<{ csvSeparator: ',' | ';' | '\t' }>();
  const [isLoading, setIsloading] = useState(false);
  const toolUsageStore = container.get(ToolUsageReportStore);
  const [errorMessageVisible, setErrorMessageVisible] = useState<boolean>(false);
  const { notification } = App.useApp();

  const handleExport = async () => {
    try {
      setIsloading(true);
      const separator = (await form.validateFields()).csvSeparator;
      const currentLanguage = i18next.language !== Languages.Russian ? i18next.language : 'ru-RU';
      const item: ToolUsageCsvReportRequest = {
        currentLanguage,
        csvSeparator: separator,
        headers: Object.entries(ToolUsageCsvReportKeys)
          .filter(([key]) => isNaN(parseInt(key)))
          .map(([key, value]) => ({ key: value as ToolUsageCsvReportKeys, translatedHeader: t(key) })),
      };
      const response = await toolUsageStore.getReport(item);
      if (response) {
        setErrorMessageVisible(false);
        onClose();
        notification.success({ message: t('ToolUsageReportInProcess'), placement: 'bottomLeft' });
      } else {
        setErrorMessageVisible(true);
      }
    } catch {
      setErrorMessageVisible(true);
    }
    setIsloading(false);
  };

  return (
    <Modal
      open={visible}
      title={t('ExportToolUsageReport')}
      onCancel={() => {
        onClose();
        setErrorMessageVisible(false);
      }}
      onOk={handleExport}
      okButtonProps={{ loading: isLoading }}
    >
      {errorMessageVisible && <Alert type="error" message={t('ErrorGeneratingReport')} />}
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item initialValue={','} name={'csvSeparator'} label={t('Separator')}>
          <Select style={{ width: '100%' }}>
            <Select.Option value={','}>{t('Comma')}</Select.Option>
            <Select.Option value={';'}>{t('Semicolon')}</Select.Option>
            <Select.Option value={'\t'}>{t('Tab')}</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
